<template>
  <div>
    <Modal
      v-model="modal"
      :title="
        !weeklyReportWarningForm.id ? '添加周报报警规则' : '编辑周报报警规则'
      "
      :loading="loading"
      :mask-closable="false"
      :styles="{ top: '65px' }"
      width="800px"
      :closable="false"
    >
      <Form
        ref="weeklyReportWarningForm"
        :model="weeklyReportWarningForm"
        :label-width="110"
        :rules="ruleValidate"
      >
        <!-- 规则名称 -->
        <FormItem label="规则名称" prop="ruleName" v-if="isEditRuleName">
          <Row>
            <Col span="11">
              <Input
                type="text"
                v-model="weeklyReportWarningForm.ruleName"
                placeholder="Enter something..."
                style="width: 300px"
                :disabled="isEdit"
              ></Input>
            </Col>
          </Row>
        </FormItem>

        <!-- 规则名称 -->
        <FormItem label="规则名称" v-if="showRuleName">
          <Row>
            <Col span="24">
              <div>{{ this.weeklyReportWarningForm.ruleName }}</div>
            </Col>
          </Row>
        </FormItem>

        <!-- 公司 -->
        <div v-if="company == 1">
          <FormItem label="公司" prop="companyId">
            <Select
              v-model="companyId"
              style="width: 300px"
              @on-change="getAccount()"
              :disabled="isEditCompany"
            >
              <Option
                :value="item.id"
                v-for="(item, index) in companyList"
                v-bind:key="index"
                >{{ item.name }}
              </Option>
            </Select>
          </FormItem>
        </div>

        <!-- 选择账号 -->
        <FormItem label="账号" prop="accountIds">
          <Select
            v-model="accountIds"
            filterable
            multiple
            :max-tag-count="1"
            placeholder="请选择账号"
            :transfer="true"
            style="width: 300px"
            @on-change="changeAccount(accountIds)"
          >
            <Checkbox
              v-model="singleAccount"
              @on-change="selectAllAccount"
              style="display: block; text-align: right"
            >
              {{ $t("alarms.common.allSelected") }}
            </Checkbox>
            <Option
              :value="item.id"
              v-for="item in accountList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>

        <!-- 选择区域 -->
        <FormItem label="区域" prop="regions">
          <Select
            v-model="regions"
            multiple
            :max-tag-count="1"
            placeholder="请选择区域"
            :transfer="true"
            @on-change="changeRegion(regions)"
            style="width: 300px"
          >
            <Checkbox
              v-model="singleRegion"
              @on-change="selectAllRegion"
              style="display: block; text-align: right"
              >{{ $t("alarms.common.allSelected") }}
            </Checkbox>
            <Option
              :value="item.key"
              v-for="item in regionList"
              :key="item.key"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>

        <!-- 规则描述 -->
        <FormItem label="规则描述">
          <Row :gutter="4">
            <!-- 监控指标 -->
            <Col span="6">
              <FormItem prop="monitorIndex">
                <Select
                  v-model="weeklyReportWarningForm.monitorIndex"
                  @on-change="
                    changeMonitorIndex(weeklyReportWarningForm.monitorIndex)
                  "
                >
                  <Option
                    :value="item.id"
                    v-for="item in monitorIndexList"
                    :key="item.id"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <!-- 周期 -->
            <Col span="3">
              <FormItem prop="cycle">
                <Select
                  v-model="weeklyReportWarningForm.cycle"
                  placeholder="周期"
                  @on-change="changeCycle(weeklyReportWarningForm.cycle)"
                >
                  <Option
                    :value="item.id"
                    v-for="(item, index) in cycleList"
                    v-bind:key="index"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <!-- 连续周期 -->
            <Col span="4">
              <FormItem prop="continousCycle">
                <Select
                  v-model="weeklyReportWarningForm.continousCycle"
                  placeholder="连续周期"
                  @on-change="
                    changeContinousCycle(weeklyReportWarningForm.continousCycle)
                  "
                >
                  <Option
                    :value="item.id"
                    v-for="(item, index) in continousCycleList"
                    v-bind:key="index"
                    >{{ item.name }}
                  </Option>
                </Select>
              </FormItem>
            </Col>
            <!-- 统计数值 -->
            <Col span="4">
              <FormItem prop="statisticsValue">
                <Select
                  v-model="weeklyReportWarningForm.statisticsValue"
                  placeholder="统计数值"
                  @on-change="
                    changeStatisticsValue(
                      weeklyReportWarningForm.statisticsValue
                    )
                  "
                >
                  <Option
                    :value="item.id"
                    v-for="(item, index) in statisticsValueList"
                    v-bind:key="index"
                  >
                    {{ item.name }}
                  </Option>
                </Select>
              </FormItem>
            </Col>

            <!-- 如果监控指标为WeeklyReport时 不显示符号、阈值和单位 -->
            <div v-if="this.isShowField != 1">
              <!-- 关系符号 -->
              <Col span="2">
                <FormItem prop="relationshipSign">
                  <Select
                    v-model="weeklyReportWarningForm.relationshipSign"
                    @on-change="
                      changeRelationshipSign(
                        weeklyReportWarningForm.relationshipSign
                      )
                    "
                    placeholder="符号"
                  >
                    <Option
                      :value="item.id"
                      v-for="(item, index) in relationshipSignList"
                      v-bind:key="index"
                    >
                      {{ item.name }}
                    </Option>
                  </Select>
                </FormItem>
              </Col>
              <!-- 阈值 -->
              <Col span="2">
                <FormItem prop="thresholdValue">
                  <Input
                    v-model="weeklyReportWarningForm.thresholdValue"
                    placeholder="阈值"
                  ></Input>
                </FormItem>
              </Col>
              <!-- 单位 -->
              <Col span="2">
                <FormItem prop="unit">
                  <Input
                    v-model="weeklyReportWarningForm.unit"
                    disabled
                    placeholder="单位"
                  ></Input>
                </FormItem>
              </Col>
            </div>
            <div v-else-if="this.isShowField == 2">
              <!-- 关系符号 -->
              <Col span="2">
                <FormItem prop="relationshipSign">
                  <Select
                    v-model="weeklyReportWarningForm.relationshipSign"
                    @on-change="
                      changeRelationshipSign(
                        weeklyReportWarningForm.relationshipSign
                      )
                    "
                    placeholder="符号"
                  >
                    <Option
                      :value="item.id"
                      v-for="(item, index) in relationshipSignList"
                      v-bind:key="index"
                    >
                      {{ item.name }}
                    </Option>
                  </Select>
                </FormItem>
              </Col>
              <!-- 阈值 -->
              <Col span="2">
                <FormItem prop="thresholdValue">
                  <Input
                    v-model="weeklyReportWarningForm.thresholdValue"
                    placeholder="阈值"
                    type="number"
                  ></Input>
                </FormItem>
              </Col>
              <!-- 单位 -->
              <Col span="2">
                <FormItem prop="unit">
                  <Input
                    v-model="weeklyReportWarningForm.unit"
                    disabled
                    placeholder="单位"
                  ></Input>
                </FormItem>
              </Col>
            </div>
          </Row>
        </FormItem>

        <!-- 联系方式 -->
        <FormItem label="联系方式" prop="contactType">
          <RadioGroup
            v-model="weeklyReportWarningForm.contactType"
            @on-change="changeContactType(weeklyReportWarningForm.contactType)"
          >
            <Radio
              v-for="item in contactTypeList"
              :label="item.type"
              :key="item.value"
              >{{ item.label }}</Radio
            >
          </RadioGroup>
        </FormItem>

        <!-- 通知对象 -->
        <FormItem
          label="通知对象"
          prop="notificationObject"
          v-if="weeklyReportWarningForm.contactType == 0"
        >
          <Select
            v-model="weeklyReportWarningForm.notificationObject"
            multiple
            style="width: 300px"
            @on-change="changeNotificationObject"
          >
            <Option
              v-for="item in notificationObjectList"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>

        <!-- 联系人组 -->
        <FormItem
          label="联系人组"
          prop="contactGroupIds"
          v-if="weeklyReportWarningForm.contactType == 1"
        >
          <Select
            v-model="weeklyReportWarningForm.contactGroupIds"
            multiple
            style="width: 300px"
            @on-change="
              changeContactGroupId(weeklyReportWarningForm.contactGroupIds)
            "
          >
            <Option
              v-for="item in contactGroupIdList"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>

        <!-- 报警方式 -->
        <FormItem label="报警方式" prop="noticeType">
          <Select
            v-model="weeklyReportWarningForm.noticeType"
            multiple
            style="width: 300px"
            @on-change="selectNoticeType(weeklyReportWarningForm.noticeType)"
          >
            <Option
              v-for="item in alarmWayList"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>

        <!-- 企业微信机器人URL -->
        <FormItem
          :label="$t('alarms.common.enterpriseWeChatRobotURL')"
          prop="enterpriseWechatRobotIds"
          v-if="
            weeklyReportWarningForm.noticeType.filter(function (e) {
              return e == 3;
            }).length != 0
          "
        >
          <Select
            v-model="weeklyReportWarningForm.enterpriseWechatRobotIds"
            multiple
            style="width: 300px"
            :placeholder="$t('alarms.common.pleaseSelect')"
          >
            <Option
              v-for="item in enterpriseWechatRobotIdsList"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>

        <!-- 延迟告警 -->
        <FormItem label="延迟告警" prop="alarmDelay">
          <Select
            v-model="weeklyReportWarningForm.alarmDelay"
            style="width: 300px"
          >
            <Option
              v-for="item in alarmDelayList"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>

        <!-- 邮箱模板 -->
        <div v-show="isShowEmail">
          <FormItem label="邮箱模板" prop="emailModal">
            <Input
              v-model="weeklyReportWarningForm.emailModal"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 5 }"
              style="width: 665px"
              disabled
            ></Input>
          </FormItem>
        </div>
      </Form>
      <div slot="footer">
        <Button size="large" @click="cancel('weeklyReportWarningForm')">{{
          $t("alarms.common.cancel")
        }}</Button>
        <Button
          type="primary"
          size="large"
          @click="ok('weeklyReportWarningForm')"
          :loading="addLoading"
          :disabled="isAddOrEdit"
        >
          {{
            !weeklyReportWarningForm.id
              ? this.$t("common.addAlarm")
              : this.$t("common.editAlarm")
          }}
        </Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../utils/cookieUtil.js";
import TableWeeklyReportWarning from "./TableWeeklyReportWarning.vue";

var tableWeeklyReportWarning = TableWeeklyReportWarning;
var tableWeeklyReportWarningVue = {};
export default {
  inject: ["reload"],
  data() {
    // 名字是否重复
    var validNameRepeatedCheck = (rule, value, callback) => {
      var self = this;
      self.$api.alertRule
        .nameRepeatedCheck({
          alertRuleName: this.weeklyReportWarningForm.ruleName,
          monitorModule: this.monitorModule,
        })
        .then((res) => {
          if (res.status == 200) {
            callback();
          }
        })
        .catch((err) => {
          if (err.status == 400) {
            callback(new Error("规则名称不能重复!"));
          }
        });
    };
    return {
      company: getCookie(global.companyId),
      companyId: "",
      companyList: [],
      addLoading: false,
      accountList: [],
      accountIds: [],
      singleAccount: false,
      regions: [],
      regionList: [],
      singleRegion: false,
      isAddOrEdit: true,
      contactTypeList: [
        {
          label: "联系人",
          value: "contact",
          type: 0,
        },
        {
          label: "联系人组",
          value: "contactGroup",
          type: 1,
        },
      ],
      isShowField: "", //是否显示符号、阈值和单位
      singleMonitorWeeklyReport: false,
      alarmDelayList: [],
      isEdit: false,
      isEditRuleName: false,
      isEditCompany: false,
      showRuleName: false,
      isShowEmail: false,
      isShowWeChat: false,
      notificationObjectList: [],
      alarmWayList: [],
      monitorWeeklyReportList: [],
      loading: true,
      modal: false,
      modal_loading: false,
      exportDataList: "",
      noticeType: [],
      units: "",
      unit: "",
      monitorModule: 15,
      weeklyReportWarningForm: {
        monitorWeeklyReports: [],
        ruleName: "",
        notificationObject: [],
        noticeType: [],
        emailModal: "",
        wechatModal: "",
        thresholdValue: "",
        monitorIndex: "",
        cycle: "",
        continousCycle: "",
        statisticsValue: "",
        relationshipSign: "",
        unit: "",
        alarmDelay: "",
        contactType: 0,
        contactGroupIds: [],
        userIdList: [],
        enterpriseWechatRobotIds: [],
      },
      enterpriseWechatRobotIdsList: [],
      // 联系人组
      contactGroupIdList: [],
      // 监控指标
      monitorIndexList: [],
      // 周期
      cycleList: [],
      // 连续周期
      continousCycleList: [],
      // 统计数值
      statisticsValueList: [],
      // 关系符号
      relationshipSignList: [],
      ruleValidate: {
        alarmDelay: [
          {
            required: true,
            message: "请选择延迟告警",
            trigger: "change",
            type: "number",
          },
        ],
        ruleName: [
          { required: true, message: "规则名称不能为空", trigger: "blur" },
          {
            type: "string",
            message: "规则名称为2-20个字符首尾中间不能有空格",
            pattern: "^[^ ]{2,20}$",
            trigger: "blur",
          },
          { validator: validNameRepeatedCheck, trigger: "blur" },
        ],
        notificationObject: [
          {
            required: true,
            type: "array",
            message: "请选择通知对象",
            trigger: "change",
          },
        ],
        noticeType: [
          {
            required: true,
            type: "array",
            min: 1,
            message: "请选择报警方式",
            trigger: "change",
          },
        ],
        monitorIndex: [
          {
            required: true,
            message: "请选择监控指标",
            trigger: "change",
            type: "number",
          },
        ],
        cycle: [
          {
            required: true,
            message: "请选择周期",
            trigger: "change",
            type: "number",
          },
        ],
        continousCycle: [
          {
            required: true,
            message: "请选择连续周期",
            trigger: "change",
            type: "number",
          },
        ],
        statisticsValue: [
          {
            required: true,
            message: "请选择统计数值",
            trigger: "change",
            type: "number",
          },
        ],
        relationshipSign: [
          {
            required: true,
            message: "请选择关系符号",
            trigger: "change",
            type: "number",
          },
        ],
        thresholdValue: [{ required: true, message: "请输入阈值" }],
        contactType: [
          {
            required: true,
            message: "请选择联系方式",
            trigger: "change",
            type: "number",
          },
        ],
        contactGroupIds: [
          {
            required: true,
            message: "请选择联系人组",
            trigger: "change",
            type: "array",
          },
        ],
        enterpriseWechatRobotIds: [
          {
            required: true,
            type: "array",
            message: "请选择企业微信机器人URL",
            trigger: "change",
          },
        ],
      },
    };
  },
  beforeCreate: function () {
    tableWeeklyReportWarningVue = this;
  },
  mounted: function () {
    if (this.company == 1) {
      this.getCompanyDropDownBox();
    }
    this.getAccount();
    this.init();
  },
  methods: {
    // 获取公司下拉框
    getCompanyDropDownBox: function () {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then((res) => {
          this.companyList = res.data;
        });
    },
    // 查询账号
    getAccount: function () {
      // 账号下拉框
      this.$api.account
        .queryAccountsByCompanyId(
          "companyId",
          this.companyId == null ||
            this.companyId == "" ||
            this.companyId == undefined
            ? this.company
            : this.companyId
        )
        .then((res) => {
          if (res.data != null && res.data.length > 0) {
            this.accountList = res.data;
          }
        });
    },
    // 全选账号
    selectAllAccount() {
      this.accountIds = [];
      if (this.singleAccount) {
        this.accountList.map((item) => {
          this.accountIds.push(item.id);
        });
      } else {
        this.accountIds = [];
      }
    },
    // 账号改变事件
    changeAccount() {
      if (this.accountIds.length == this.accountList.length) {
        this.singleAccount = true;
      } else {
        this.singleAccount = false;
      }
      this.getRegions();
    },
    getRegions: function () {
      let account = "";
      if (this.accountIds.length > 0) {
        account = this.accountIds[0];
      } else {
        return;
      }
      // 查询地区
      this.$api.account
        .queryAccountRegions("accountId", account)
        .then((res) => {
          if (res.data != null && res.data.length > 0) {
            this.regionList = res.data;
            // 只有新增才默认勾选区域
            if (this.weeklyReportWarningForm.id <= 0) {
              // 默认全选区域
              for (let i = 0; i < this.regionList.length; i++) {
                this.regions.push(this.regionList[i].name);
              }
            }
          }
        });
    },
    // 切换区域
    changeRegion: function () {
      if (
        this.regions.length === this.regionList.length &&
        this.regions.length > 0
      ) {
        this.singleRegion = true;
      } else {
        this.singleRegion = false;
      }
    },
    // 全选区域
    selectAllRegion: function () {
      this.regions = [];
      if (this.singleRegion) {
        this.regionList.map((item) => {
          this.regions.push(item.key);
        });
      } else {
        this.regions = [];
      }
    },
    //显示表格数据
    /****************************************************************/
    init: function (id) {
      this.weeklyReportWarningForm.id = id || 0;
      // 查询联系人组
      tableWeeklyReportWarningVue.listContactGroups();
      // 查询账号
      tableWeeklyReportWarningVue.getAccount();
      // 查询规则描述
      tableWeeklyReportWarningVue.searchMonitorIndex();
      // 查询通知对象
      tableWeeklyReportWarningVue.queryContacts();
      // 查询方式
      tableWeeklyReportWarningVue.alarmWay();
      // 查询报警延时
      tableWeeklyReportWarningVue.getAlarmDelay();
      // 监控模块查询关联的机器人列表
      tableWeeklyReportWarningVue.listEnterpriseWechatRobotsByMonitorModule();
      this.$nextTick(() => {
        // 重置表单
        this.$refs["weeklyReportWarningForm"].resetFields();
        // 编辑
        if (this.weeklyReportWarningForm.id) {
          // 编辑显示不能输入的规则名称
          this.showRuleName = true;
          this.isEdit = true;
          this.isEditCompany = true;
          this.$api.alertRule
            .selectAlertRule("id", this.weeklyReportWarningForm.id)
            .then((res) => {
              //延时
              this.weeklyReportWarningForm.alarmDelay = res.data.delay;
              // 邮箱
              this.weeklyReportWarningForm.monitorWeeklyReports =
                res.data.monitorWeeklyReports;
              // 规则名称
              this.weeklyReportWarningForm.ruleName = res.data.alertRuleName;

              // 监控指标
              /******************************************************/
              // 查询监控指标
              tableWeeklyReportWarningVue.$api.alertRule
                .searchDefaultMonitorIndex("monitorModule", this.monitorModule)
                .then((res) => {
                  this.monitorIndexList = res.data;
                });
              this.weeklyReportWarningForm.monitorIndex = res.data.monitorIndex;
              // 如果监控指标为WeeklyReport时 不显示符号、阈值和单位
              if (
                this.weeklyReportWarningForm.monitorIndex == 61 ||
                this.weeklyReportWarningForm.monitorIndex == 62
              ) {
                this.isShowField = 1;
              } else {
                this.isShowField = 2;
              }

              // 周期
              this.weeklyReportWarningForm.cycle = res.data.cycle;
              // 连续周期
              this.weeklyReportWarningForm.continousCycle =
                res.data.continousCycle;
              // 统计数值
              this.weeklyReportWarningForm.statisticsValue =
                res.data.statisticsValue;
              // 符号
              this.weeklyReportWarningForm.relationshipSign =
                res.data.relationshipSign;
              // 阈值
              this.weeklyReportWarningForm.thresholdValue =
                res.data.thresholdStringValue;
              // 单位
              this.weeklyReportWarningForm.unit = res.data.unit;
              this.units = res.data.unitId;
              // 企业微信机器人URL
              this.weeklyReportWarningForm.enterpriseWechatRobotIds =
                res.data.enterpriseWechatRobotIds;

              // 联系方式
              this.weeklyReportWarningForm.contactType = res.data.contactType;
              if (res.data.contactType == 0) {
                // 通知对象
                this.weeklyReportWarningForm.notificationObject =
                  res.data.contactIDs;
                for (
                  let i = 0;
                  i < this.weeklyReportWarningForm.notificationObject.length;
                  i++
                ) {
                  for (let j = 0; j < this.notificationObjectList.length; j++) {
                    if (
                      this.weeklyReportWarningForm.notificationObject[i] ==
                      this.notificationObjectList[j].id
                    ) {
                      this.weeklyReportWarningForm.userIdList.push(
                        this.notificationObjectList[j].userId
                      ); //传值
                    }
                  }
                }
              } else if (res.data.contactType == 1) {
                // 联系人组
                this.$api.contactGroup.listContactGroups().then((res) => {
                  this.contactGroupIdList = res.data;
                });
                setTimeout(() => {
                  this.weeklyReportWarningForm.contactGroupIds =
                    res.data.contactGroupIds;
                }, 1000);
              }

              // 查询阈值
              tableWeeklyReportWarningVue.selectMonitorIndexDefault();

              // 报警方式
              this.weeklyReportWarningForm.noticeType = res.data.noticeType;

              for (
                let i = 0;
                i < this.weeklyReportWarningForm.noticeType.length;
                i++
              ) {
                if (this.weeklyReportWarningForm.noticeType[i] == "0") {
                  this.isShowEmail = true;
                  this.weeklyReportWarningForm.emailModal =
                    res.data.briefReportBodyMail;
                  this.noticeType = this.weeklyReportWarningForm.noticeType;
                  tableWeeklyReportWarningVue.selectTemplate();
                }
                if (this.weeklyReportWarningForm.noticeType[i] == "1") {
                  // this.isShowWeChat = true;
                  this.weeklyReportWarningForm.wechatModal =
                    res.data.briefReportBodyWechat;
                  this.checkLeastOnePersonBoundWeChat();
                  this.noticeType = this.weeklyReportWarningForm.noticeType;
                  tableWeeklyReportWarningVue.selectTemplate();
                } else if (this.weeklyReportWarningForm.noticeType[i] != "1") {
                  this.wechatWarningVisible = false;
                  this.isAddOrEdit = false;
                }
              }
              if (
                res.data.companyId != null &&
                res.data.companyId != undefined &&
                res.data.companyId != ""
              ) {
                this.companyId = res.data.companyId;
              }
              if (
                res.data.accountIDs != null &&
                res.data.accountIDs != undefined &&
                res.data.accountIDs != ""
              ) {
                this.accountIds = res.data.accountIDs;
                this.changeAccount();
              }
              if (
                res.data.regions != null &&
                res.data.regions != undefined &&
                res.data.regions != ""
              ) {
                this.regions = res.data.regions;
                this.changeRegion();
              }
            });
        } else {
          this.isEdit = false;
          // 添加显示规则名称能输入
          this.isEditRuleName = true;
          this.isEditCompany = false;
          this.showRuleName = false;
        }
      });
      this.modal = true;
    },
    // 根据监控指标 显示不同单位
    /****************************************************************/
    // 清空周期、连续周期、统计数值、关系符号
    emptyDate: function () {
      this.weeklyReportWarningForm.cycle = "";
      this.weeklyReportWarningForm.continousCycle = "";
      this.weeklyReportWarningForm.statisticsValue = "";
      this.weeklyReportWarningForm.relationshipSign = "";
      this.weeklyReportWarningForm.thresholdValue = "";
    },
    isNotEmpty: function (obj) {
      if (typeof obj === "undefined" || obj === null || obj === "") {
        return false;
      } else {
        return true;
      }
    },
    // 根据监控指标 显示不同单位
    changeMonitorIndex: function () {
      // 如果监控指标为WeeklyReport时 不显示符号、阈值和单位
      if (
        this.weeklyReportWarningForm.monitorIndex == 61 ||
        this.weeklyReportWarningForm.monitorIndex == 62
      ) {
        this.isShowField = 1;
      } else {
        this.isShowField = 2;
      }
      tableWeeklyReportWarningVue.selectMonitorIndexDefault();
      this.unit = this.weeklyReportWarningForm.monitorIndex;
      for (var i = 0; i < this.monitorIndexList.length; i++) {
        if (this.monitorIndexList[i].id == this.unit) {
          this.weeklyReportWarningForm.unit = this.monitorIndexList[i].unit;
          this.units = this.monitorIndexList[i].id;
        }
      }
      tableWeeklyReportWarningVue.selectTemplate();
      tableWeeklyReportWarningVue.emptyDate();
    },
    // 查询阈值
    /****************************************************************/
    selectMonitorIndexDefault: function () {
      tableWeeklyReportWarningVue.$api.alertRule
        .selectMonitorIndexDefault({
          monitorIndex: this.weeklyReportWarningForm.monitorIndex,
          monitorModule: this.monitorModule,
          cycle: this.weeklyReportWarningForm.cycle,
          continousCycle: this.weeklyReportWarningForm.continousCycle,
          statisticsValue: this.weeklyReportWarningForm.statisticsValue,
          relationshipSign: this.weeklyReportWarningForm.relationshipSign,
        })
        .then((res) => {
          // 周期
          this.cycleList = res.data.cycleMap;
          // 连续周期
          this.continousCycleList = res.data.continousCycleMap;
          // 统计数值
          this.statisticsValueList = res.data.statisticsValueMap;
          // 关系符号
          this.relationshipSignList = res.data.relationshipSignMap;
          // 阈值
          if (
            res.data.companyMonitoritemVariablesList.length == 1 &&
            tableWeeklyReportWarningVue.isNotEmpty(
              this.weeklyReportWarningForm.cycle
            ) &&
            tableWeeklyReportWarningVue.isNotEmpty(
              this.weeklyReportWarningForm.continousCycle
            ) &&
            tableWeeklyReportWarningVue.isNotEmpty(
              this.weeklyReportWarningForm.statisticsValue
            ) &&
            tableWeeklyReportWarningVue.isNotEmpty(
              this.weeklyReportWarningForm.relationshipSign
            ) &&
            this.weeklyReportWarningForm.id == 0
          ) {
            this.weeklyReportWarningForm.thresholdValue =
              res.data.companyMonitoritemVariablesList[0].customerMonitorIndexDefaultValue;
          }
        });
    },
    // 查询邮件模板
    /****************************************************************/
    selectTemplate: function () {
      tableWeeklyReportWarningVue.$api.briefReport
        .selectTemplate({
          monitorIndex: this.weeklyReportWarningForm.monitorIndex,
          relationshipSign: this.weeklyReportWarningForm.relationshipSign,
          monitorModule: this.monitorModule,
          noticeType: this.weeklyReportWarningForm.noticeType,
        })
        .then((res) => {
          this.weeklyReportWarningForm.wechatModal =
            res.data.briefReportBodyWechat;
          this.weeklyReportWarningForm.emailModal =
            res.data.briefReportBodyMail;
        });
    },
    //报警方式为邮箱显示邮箱模板  为企业微信显示企业微信模板
    selectNoticeType: function () {
      this.isShowEmail = false;
      this.isShowWeChat = false;
      for (var i = 0; i < this.weeklyReportWarningForm.noticeType.length; i++) {
        if (this.weeklyReportWarningForm.noticeType[i] == "0") {
          this.isShowEmail = true;
          this.noticeType = this.weeklyReportWarningForm.noticeType;
          tableWeeklyReportWarningVue.selectTemplate();
        }
        if (this.weeklyReportWarningForm.noticeType[i] == "1") {
          // this.isShowWeChat = true;
          this.noticeType = this.weeklyReportWarningForm.noticeType;
          this.checkLeastOnePersonBoundWeChat();
          tableWeeklyReportWarningVue.selectTemplate();
        } else if (this.weeklyReportWarningForm.noticeType[i] != "1") {
          this.wechatWarningVisible = false;
          this.isAddOrEdit = false;
        }
      }
    },
    // 检查至少有一人绑定过微信
    checkLeastOnePersonBoundWeChat: function () {
      for (var i = 0; i < this.weeklyReportWarningForm.noticeType.length; i++) {
        if (this.weeklyReportWarningForm.noticeType[i] == 1) {
          var weChatDate = {
            contactType: this.weeklyReportWarningForm.contactType,
          };
          // 联系方式为 -联系人-
          if (this.weeklyReportWarningForm.contactType == 0) {
            weChatDate.userIds = this.weeklyReportWarningForm.userIdList;
          }
          // 联系方式为 -联系人组-
          else if (this.weeklyReportWarningForm.contactType == 1) {
            weChatDate.contactGroupIds =
              this.weeklyReportWarningForm.contactGroupIds;
          }
          this.$api.userWeChat
            .checkLeastOnePersonBoundWeChat(weChatDate)
            .then((res) => {
              if (res.data) {
                this.isAddOrEdit = false;
              } else {
                this.isAddOrEdit = true;
              }
            });
        } else if (this.weeklyReportWarningForm.noticeType[i] != 1) {
          this.isAddOrEdit = false;
        }
      }
    },
    // 联系人组
    listContactGroups: function () {
      this.$api.contactGroup.listContactGroups().then((res) => {
        this.contactGroupIdList = res.data;
      });
    },
    // 切换联系人组
    changeContactGroupId: function () {
      this.checkLeastOnePersonBoundWeChat();
    },
    // 切换通知对象
    changeNotificationObject: function (val) {
      this.weeklyReportWarningForm.userIdList = [];
      this.weeklyReportWarningForm.notificationObject = val;
      for (
        var i = 0;
        i < this.weeklyReportWarningForm.notificationObject.length;
        i++
      ) {
        for (var j = 0; j < this.notificationObjectList.length; j++) {
          if (
            this.weeklyReportWarningForm.notificationObject[i] ==
            this.notificationObjectList[j].id
          ) {
            this.weeklyReportWarningForm.userIdList.push(
              this.notificationObjectList[j].userId
            ); //传值
          }
        }
      }
      this.checkLeastOnePersonBoundWeChat();
    },
    // 切换联系方式
    changeContactType: function () {
      this.checkLeastOnePersonBoundWeChat();
    },
    /**************************************  查询  **************************************/
    // 监控模块查询关联的机器人列表
    listEnterpriseWechatRobotsByMonitorModule: function () {
      tableWeeklyReportWarningVue.$api.enterpriseWechatRobot
        .listEnterpriseWechatRobotsByMonitorModule({
          monitorModule: this.monitorModule,
        })
        .then((res) => {
          this.enterpriseWechatRobotIdsList = res.data;
        });
    },
    // 查询监控指标
    searchMonitorIndex: function () {
      tableWeeklyReportWarningVue.$api.alertRule
        .searchDefaultMonitorIndex("monitorModule", this.monitorModule)
        .then((res) => {
          this.monitorIndexList = res.data;
        });
    },
    // 查询通知对象
    queryContacts: function () {
      tableWeeklyReportWarningVue.$api.contact
        .queryContacts("monitorModule", this.monitorModule)
        .then((res) => {
          this.notificationObjectList = res.data.contactList;
          this.weeklyReportWarningForm.notificationObject =
            res.data.defaultContactIds;
        });
    },
    // 查询报警方式
    alarmWay: function () {
      tableWeeklyReportWarningVue.$api.alertRule
        .alarmWay("userName", getCookie(global.cookieName))
        .then((res) => {
          this.alarmWayList = res.data;
        });
    },
    // 查询报警延迟
    getAlarmDelay: function () {
      tableWeeklyReportWarningVue.$api.alertRule
        .alarmDelay("userName", getCookie(global.cookieName))
        .then((res) => {
          this.alarmDelayList = res.data;
        });
    },
    // 周期
    changeCycle: function () {
      // 查询阈值
      tableWeeklyReportWarningVue.selectMonitorIndexDefault();
    },
    // 连续周期
    changeContinousCycle: function () {
      // 查询阈值
      tableWeeklyReportWarningVue.selectMonitorIndexDefault();
    },
    // 统计数值
    changeStatisticsValue: function () {
      // 查询阈值
      tableWeeklyReportWarningVue.selectMonitorIndexDefault();
    },
    // 关系符号
    changeRelationshipSign: function () {
      // 查询阈值
      tableWeeklyReportWarningVue.selectMonitorIndexDefault();
      // 邮件模板
      tableWeeklyReportWarningVue.selectTemplate();
    },

    /***********邮箱**************************/
    selectMonitorWeeklyReportAll() {
      this.weeklyReportWarningForm.monitorWeeklyReports = [];
      if (this.singleMonitorWeeklyReport) {
        this.monitorWeeklyReportList.map((item) => {
          this.weeklyReportWarningForm.monitorWeeklyReports.push(item.id);
        });
      } else {
        this.weeklyReportWarningForm.monitorWeeklyReports = [];
      }
    },
    // 切换邮箱
    changeMonitorWeeklyReport: function (val) {
      if (
        val.length === this.monitorWeeklyReportList.length &&
        val.length != 0
      ) {
        this.singleMonitorWeeklyReport = true;
      } else {
        this.singleMonitorWeeklyReport = false;
      }
    },
    // 创建添加或编辑报警
    /**********************************************************************************/
    ok: function (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          var alertList = {
            alertRuleName: this.weeklyReportWarningForm.ruleName,
            monitorIndex: this.weeklyReportWarningForm.monitorIndex,
            accountId: this.accountIds[0],
            cycle: this.weeklyReportWarningForm.cycle,
            continousCycle: this.weeklyReportWarningForm.continousCycle,
            statisticsValue: this.weeklyReportWarningForm.statisticsValue,
            relationshipSign: this.weeklyReportWarningForm.relationshipSign,
            monitorModule: this.monitorModule,
            noticeType: this.weeklyReportWarningForm.noticeType,
            unit: this.units,
            delay: this.weeklyReportWarningForm.alarmDelay,
            thresholdStringValue: this.weeklyReportWarningForm.thresholdValue,
            contactType: this.weeklyReportWarningForm.contactType,
            enterpriseWechatRobotIds:
              this.weeklyReportWarningForm.enterpriseWechatRobotIds,
          };
          // 周报
          var weeklyReportDTO = {
            accountIds: this.accountIds,
            regions: this.regions,
          };
          alertList.weeklyReportDTO = weeklyReportDTO;

          // 如果联系方式是联系人 传通知对象
          if (this.weeklyReportWarningForm.contactType == 0) {
            alertList.contactIDs =
              this.weeklyReportWarningForm.notificationObject;
          }
          // 如果联系方式是联系人组 传联系人组
          else if (this.weeklyReportWarningForm.contactType == 1) {
            alertList.contactGroupIds =
              this.weeklyReportWarningForm.contactGroupIds;
          }

          if (this.weeklyReportWarningForm.id > 0) {
            alertList.id = this.weeklyReportWarningForm.id;
            // 编辑告警
            this.addLoading = true;
            tableWeeklyReportWarningVue.$api.alertRule
              .updateAlertRule(alertList)
              .then((res) => {
                this.data = res.data;
                setTimeout(() => {
                  this.reload();
                  this.weeklyReportWarningForm.notificationObject = [];
                  this.$refs[name].resetFields();
                  this.loading = false;
                  this.$nextTick(() => {
                    this.loading = true;
                  });
                  this.$Message.success("编辑成功");
                  this.isShowEmail = false;
                  this.isShowWeChat = false;
                  this.addLoading = false;
                  this.modal = false;
                  this.isAddOrEdit = true;
                }, 1000);
              });
          } else {
            // 添加告警
            this.addLoading = true;
            tableWeeklyReportWarningVue.$api.alertRule
              .createAlertRule(alertList)
              .then((res) => {
                this.data = res.data;
                setTimeout(() => {
                  this.reload();
                  this.weeklyReportWarningForm.notificationObject = [];
                  this.$refs[name].resetFields();
                  this.loading = false;
                  this.$nextTick(() => {
                    this.loading = true;
                  });
                  this.$Message.success("添加成功");
                  this.monitorIndexList = [];
                  this.isShowEmail = false;
                  this.isShowWeChat = false;
                  this.addLoading = false;
                  this.modal = false;
                  this.isAddOrEdit = true;
                }, 1000);
              });
          }
        } else {
          //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
          this.loading = false;
          setTimeout(() => {
            this.loading = true;
          }, 0);
          if (this.weeklyReportWarningForm.id > 0) {
            this.$Message.error("编辑失败");
          } else {
            this.$Message.error("添加失败");
          }
        }
      });
    },
    // 取消
    cancel: function (name) {
      this.companyId = [];
      this.accountIds = [];
      this.regions = [];
      this.isAddOrEdit = true;
      this.isShowEmail = false;
      this.isShowWeChat = false;
      this.monitorIndexList = [];
      this.$nextTick(() => {
        this.$refs[name].resetFields();
      });
      this.modal = false;
    },
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/monitor/weeklyReport/AddOrUpdateWeeklyReportWarning.vue